"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TrashOffSmallOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TrashOffSmallOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.313 2.566-.498-.748A1.632 1.632 0 0 0 9.41 1H6.59c-.583 0-1.111.318-1.405.818L3.732 4H1.5a.5.5 0 0 0 0 1h.584l.526 6.269.926-.926L3.087 5H8.88l1-1H4.934l1.102-1.654.008-.015A.633.633 0 0 1 6.59 2h2.82c.214 0 .424.118.546.33l.009.016.627.941.72-.721Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.788 7.091A.5.5 0 0 0 6 7.5v.379l.788-.788Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.14 15.154 14.3-14.3a.37.37 0 0 0 .007-.008l.7-.7a.5.5 0 0 1 .707.708L12.707 4H14.5a.5.5 0 0 1 0 1h-.584l-.724 8.625A1.5 1.5 0 0 1 11.697 15H4.303a1.5 1.5 0 0 1-1.456-1.14L.854 15.855a.5.5 0 0 1-.715-.7ZM6 11.5v-.793l-2.245 2.245.05.59a.5.5 0 0 0 .497.458h7.396a.5.5 0 0 0 .498-.458L12.913 5h-1.206L9.675 7.032A.5.5 0 0 1 10 7.5v4a.5.5 0 0 1-1 0V7.707l-2 2V11.5a.5.5 0 0 1-1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TrashOffSmallOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TrashOffSmallOutline;
exports["default"] = _default;